import { createContext } from 'react';

export interface MapRegionsContext {
  ready: boolean;
  setReady: (value: boolean) => void;
}

export interface IMapContext {
  map?: mapboxgl.Map;
  draw?: any;
  mapRegionsContext?: MapRegionsContext;
}

const MapContext = createContext<IMapContext>({});

export default MapContext;
